import { render, staticRenderFns } from "./UserTrdocs.vue?vue&type=template&id=06194796&scoped=true"
import script from "./UserTrdocs.vue?vue&type=script&lang=js"
export * from "./UserTrdocs.vue?vue&type=script&lang=js"
import style0 from "./UserTrdocs.vue?vue&type=style&index=0&id=06194796&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06194796",
  null
  
)

export default component.exports